import { FC, useMemo } from 'react';
import { ButtonLink as ButtonLinkEntry } from '@oresundsbron/api';
import { Button, ButtonProps } from '@oresundsbron/bridge-ui';
import { useLinksV2 } from '~/hooks/useLinksV2';
import Link from 'next/link';

export const ButtonLink: FC<ButtonLinkEntry> = ({
  text,
  variant,
  pageLink,
  externalUrl,
  inverted,
}) => {
  const { getLink } = useLinksV2();

  const {
    locale: linkLocale,
    path,
    target,
  } = useMemo(() => {
    if (pageLink?.sys?.id) {
      const resolved = getLink(pageLink.sys.id);
      if (resolved) {
        return {
          locale: resolved?.locale,
          path: resolved?.path,
          target: undefined,
        };
      }
    }

    if (externalUrl) {
      return { locale: undefined, path: externalUrl, target: '_blank' };
    }

    return { locale: undefined, path: undefined, target: undefined };
  }, [pageLink, externalUrl, getLink]);

  const href = path ?? '';
  const intent = variant as ButtonProps['intent'];
  const color = inverted ? 'white' : undefined;

  return (
    <Button
      as={Link}
      href={href}
      locale={linkLocale}
      target={target}
      intent={intent}
      color={color}
      className="mr-4"
    >
      {text}
    </Button>
  );
};
